import React from 'react';
import PropTypes from 'prop-types';
import { View, Text } from 'react-native-web';

import getProgramTypesFromTabs from '../helpers/getProgramTypesFromTabs';
import { MainTabEnum, SubTabEnum } from '../../../../shared/discover-tabs-enum';
import { Button } from '../../../../shared-components/base-components';
import { useSelectedParams } from '../../../../hooks';
import { snakeToStartCase } from '../../../../utils';

import styles from '../styles';

const propTypes = {
  subTab: PropTypes.string,
  mainTab: PropTypes.string,
  onPress: PropTypes.func.isRequired,
  selectedProgramTypes: PropTypes.arrayOf(PropTypes.string),
};

const defaultProps = {
  subTab: SubTabEnum.LEAGUE,
  mainTab: MainTabEnum.SPORTS,
  selectedProgramTypes: undefined,
};

const ProgramTypeFilter = ({
  subTab,
  mainTab,
  onPress,
  // used if program types are present in url params
  selectedProgramTypes,
}) => {
  const [selected, setSelected] = useSelectedParams(selectedProgramTypes, onPress);

  const currentProgramTypes = selectedProgramTypes || selected;

  const programTypes = getProgramTypesFromTabs(mainTab, subTab);

  return (
    <View style={styles.container}>
      <View style={styles.row}>
        {programTypes.length > 0 ? (
          programTypes.map(type => (
            <Button
              key={type}
              value={snakeToStartCase(type)}
              variant="outline"
              onPress={() => setSelected(type)}
              pressed={currentProgramTypes.includes(type)}
              style={styles.button}
            />
          ))
        ) : (
          <Text>No programs found</Text>
        )}
      </View>
    </View>
  );
};

ProgramTypeFilter.propTypes = propTypes;
ProgramTypeFilter.defaultProps = defaultProps;

export default ProgramTypeFilter;
